export const faqData = [
  {
    id: 1,
    question: "What credit score is needed for a personal loan?",
    answer:
      "Scores above 750 are generally ideal, but options are available for lower scores, though they may carry higher rates.",
  },
  {
    id: 2,
    question: "Can I get a loan with a low credit score?",
    answer:
      " Yes, some lenders provide loans for fair or poor scores but often at higher interest rates.",
  },
  {
    id: 3,
    question: "How does a personal loan affect my credit?",
    answer:
      "Timely payments can improve your credit score, while missed payments can damage it.",
  },
];
